import { Anchor, Button, DownloadSVG, ExternalLinkSVG } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
  WithTrackEventProps,
} from "@newsela/snitch";

import {
  DOWNLOAD_PDF_LABEL_FOR_ALL_FORMS_COMPLETED,
  DOWNLOAD_PDF_LABEL_FOR_INCOMPLETE_FORMS,
} from "../../constants";
import { buttonsContainerCss } from "./HeaderActionButtons.style";

type AnchorProps = React.ComponentProps<typeof Anchor> | WithTrackEventProps;
const AnchorWithTrackEvent = withTrackEvent(
  Anchor,
) as React.ForwardRefExoticComponent<
  AnchorProps & React.RefAttributes<HTMLAnchorElement>
>;

interface Props {
  areFormsCompleted: boolean | undefined | null;
  downloadPDFPath?: string;
  isPDFOutput?: boolean;
}

const HeaderActionButtons = (props: Props) => {
  const { areFormsCompleted, isPDFOutput = false, downloadPDFPath } = props;
  return (
    <div css={buttonsContainerCss}>
      {!isPDFOutput && downloadPDFPath && (
        <AnchorWithTrackEvent
          openInNewTab
          href={downloadPDFPath}
          icon={{
            isIconBeforeText: true,
            SvgComponent: DownloadSVG,
            __customOpenInNewTabIcon: DownloadSVG,
          }}
          styleAnchorAsButton={{
            flavor: Button.flavors.primary,
            size: Button.sizes.md,
          }}
          objectType={objectTypes.user}
          actionPrefix={actionPrefixes.initiate}
          actionName={actionNames.download}
          streamProperties={{
            description: "Download guide",
          }}
          dataProps={{
            "data-qa-selector": "download-implementation-guide-pdf",
          }}
        >
          {areFormsCompleted
            ? DOWNLOAD_PDF_LABEL_FOR_ALL_FORMS_COMPLETED
            : DOWNLOAD_PDF_LABEL_FOR_INCOMPLETE_FORMS}
        </AnchorWithTrackEvent>
      )}
      <AnchorWithTrackEvent
        openInNewTab
        icon={{
          SvgComponent: ExternalLinkSVG,
          isIconBeforeText: true,
        }}
        styleAnchorAsButton={{
          flavor: Button.flavors.secondary,
          size: Button.sizes.md,
        }}
        objectType="User"
        actionName={actionNames.navigate}
        href="https://newsela.com/about/resource/?tab=0"
        streamProperties={{
          description: "Admin resource hub",
        }}
        dataProps={{ "data-qa-selector": "open-admin-resource-hub" }}
      >
        Admin resource hub
      </AnchorWithTrackEvent>
    </div>
  );
};

export default HeaderActionButtons;
